import { Refinance } from '../../components/meta';
import page from '../shared/qualify/page';

export default ({ path, actionPipe }) =>
  page({
    path,
    actionPipe,
    scenario: 'RefiQualify',
    meta: Refinance
  });



// WEBPACK FOOTER //
// ./src/products/refi-qualify/index.js